import contentfulClient from 'utils/contentfulService';

export const getCourseSavedResources = async (
  _,
  localeFilter,
  savedResourceIds,
) => {
  const resources = await contentfulClient.getEntries({
    'sys.id[in]': savedResourceIds.toString(),
    include: 1,
    ...localeFilter,
  });

  return resources.items;
};
